import config from 'site.config.json'

const {
  configuration: { assetPath }
} = config

class ConfigService {
  async request() {
    let url = `${process.env.REACT_APP_JSON_URL}/${assetPath}/content.json`
    const response = await fetch(url, { method: 'GET' })
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const responseData = await response.json()
    return responseData
  }
}

export default ConfigService
